import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { UserService } from '@core/services/user.service';

export const AuthGuard: CanActivateFn = () => {
  const router = inject(Router);
  const userService = inject(UserService);

  // 1) Validación local
  // const session = userService.getUserInfo();
  // console.log('session 1 => ',session);
  // if (!session) {
  //   router.navigate(['/auth/login']);
  //   return of(false);
  // }

  // 2) Validación backend
  return userService.checkSession().pipe(
    map(() => true),
    catchError(() => {
      router.navigate(['/auth/login']);
      return of(false);
    })
  );
};
